"use client";

/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from "react";
import { isBoolean } from "@huub-web/utils";

import type { FormInputProps } from "../components";
import { type FormInputType, FormInputTypeOptions } from "../types";

/**
 * useDynamicFormInput hook is used to validate the type of the dynamic input field.
 */
export const useDynamicFormInput = ({
  value,
  type = "string",
}: Pick<FormInputProps, "value" | "type">) => {
  const [isInvalidType, setInvalidType] = useState(false);

  useEffect(() => {
    const isInvalid = !FormInputTypeOptions.includes(type);
    setInvalidType(isInvalid);
  }, [type]);

  const parsedType: FormInputType = (() => {
    if (
      isBoolean(value) ||
      ["true", "false"].includes(value as string) ||
      ["boolean", "bool"].includes(type as any)
    ) {
      if (
        isBoolean(value) &&
        type !== "boolean" &&
        type !== "check" &&
        type !== "radio"
      ) {
        console.warn(
          `Invalid type for boolean value, expected type 'boolean', got '${type}'`,
        );
      }
      if (type === "check") {
        return "check";
      }
      if (type === "radio") {
        return "radio";
      }
      return "boolean";
    }

    if ((type as any) === "str") {
      return "string";
    }

    if (!FormInputTypeOptions.includes(type)) {
      console.warn("Invalid type", type);
      return "string";
    }

    return type;
  })();

  return { isInvalidType, parsedType };
};
